import { getters } from './getters'
import { APP_TOGGLE_MENU, APP_INTERNAL_MENU, APP_LOAD_THEME, APP_TOGGLE_SEARCH, APP_INIT_LOADING, APP_INIT_SUCCESS, APP_INIT_FAIL, APP_LOGIN_MENU, USER_TOKEN_REMOVE } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { Menu } from '@/const/menu'
import { flattenMenu } from '@/utils/menu'
import Router, { routes } from '@/router'
import { initStompClient } from '@/websocket'
/**
 * This is where it hold the states
 */
const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initMessage: '',
  // Application menu
  // internalMenu: Breadcrumb generation, Title Fetching
  // routeMenu: flatten route menu. Mainly use for access checking
  internalMenu: {},
  routeMenu: {},
  // Base API Menu (inclusive of login, health check api etc)
  baseMenu: {},
  // API menu (after login)
  menu: {},
  // web socket related
  wsLink: undefined,
  wsSubscribe: {},
  toggleMenu: true,
  toggleSearch: false,
  loadTheme: false,
  // mainColor: 'indigo',
  mainColor: 'primary',
  projectTitle: process.env.VUE_APP_TITLE,
  projectTitleLong: process.env.VUE_APP_TITLE_LONG
}

/**
 * These are functions that modify the state
 * Note: do not perform any async actions here (do it in actions)
 */
const mutations = {
  [APP_INIT_LOADING](state) {
    state.init = 0
    state.initMessage = 'Loading Application. Please wait...'
    state.baseMenu = {}
    state.menu = {}
  },
  [APP_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initMessage = 'Application loaded. Transferring you to another page...'
    state.baseMenu = data.menu
  },
  [APP_INIT_FAIL](state) {
    state.init = 2
    state.initMessage = 'Failed to load Application. If the problem persist, the server might be down for maintenance. Please contact your System Administrator for more information.'
    state.baseMenu = {}
  },
  [APP_TOGGLE_MENU](state, data) {
    if (data !== null && data !== undefined) {
      state.toggleMenu = data
    } else {
      state.toggleMenu = !state.toggleMenu
    }
  },
  [APP_TOGGLE_SEARCH](state, data) {
    if (data === undefined) {
      state.toggleSearch = !state.toggleSearch
    } else {
      state.toggleSearch = data
    }
  },
  [APP_INTERNAL_MENU](state, data) {
    state.internalMenu = data.normal
    state.routeMenu = data.route
  },
  [APP_LOAD_THEME](state, data) {
    state.loadTheme = data
    state.toggleMenu = data
  },
  [APP_LOGIN_MENU](state, data) {
    state.menu = data.menu
    state.wsLink = data.wsLink
    state.wsSubscribe = data.wsSubscribe
  }
}

/**
 * This is where we dispatch actions that will commit the state with mutation functions
 */
const actions = {
  // preLoadApp must be done before route is confirm (as access control depends on this)
  preLoadApp({ commit }) {
    // We will flatten the internal menu object and store to vuex here
    // flattened obj is easier and faster to do search and resolving relation (breadcrumb)
    const menus = {
      normal: flattenMenu(Menu),
      route: flattenMenu(routes)
    }
    commit(APP_INTERNAL_MENU, menus)
  },
  appInit({ commit, rootState, dispatch }) {
    commit(APP_INIT_LOADING)
    const apiUrl = process.env.VUE_APP_APIURL
    http.get(apiUrl)
      .then(function (response) {
        const { data } = response
        const menu = extractMenu(data._links)
        const commitResult = {
          menu: menu
        }
        // Check if there is existing token
        // If yes, revalidate the login
        if (rootState.token.token && rootState.token.token !== '') {
          if (menu.validateSession) {
            http.get(menu.validateSession)
              .then(function (loginResponse) {
                const menu = extractMenu(loginResponse.data._links)
                commit(APP_INIT_SUCCESS, commitResult)

                const commitMenu = {
                  menu: menu,
                  wsLink: loginResponse.data.wsLink,
                  wsSubscribe: loginResponse.data.wsSubscribe
                }
                commit(APP_LOGIN_MENU, commitMenu)

                // Post Login Init
                dispatch('postLoginInit')
              })
              .catch(function (loginError) {
                commit(APP_INIT_SUCCESS, commitResult)
                commit(USER_TOKEN_REMOVE)
                Router.push({ name: 'login' })
              })
          } else {
            commit(APP_INIT_SUCCESS, commitResult)
            commit(USER_TOKEN_REMOVE)
            Router.push({ name: 'login' })
          }
        } else {
          commit(APP_INIT_SUCCESS, commitResult)
        }
      })
      .catch(function (error) {
        // Fail
        commit(APP_INIT_FAIL)
      })
  },
  // This method is called after credential is confirmed (post login and page refresh token validated)
  postLoginInit({ commit, rootState, dispatch }) {
    // Init Websocket here
    initStompClient()

    // Init Notification here
    dispatch('initNotification')
  }
}

export default {
  // It supports state, getters, mutations, actions
  state,
  getters,
  mutations,
  actions
}
